import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Games & Guilds", path: "/games-guilds" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/5 shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 flex items-center justify-between h-[72px]">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 group cursor-pointer">
          <div className="w-8 h-8 flex items-center justify-center rounded-sm bg-[#00ff88]/10 border border-[#00ff88]/30 group-hover:bg-[#00ff88]/20 transition-all">
            <i className="ri-anchor-line text-[#00ff88] text-lg leading-none" />
          </div>
          <div>
            <div className="text-white font-bold text-base tracking-widest leading-none font-inter">
              AWWAL
            </div>
            <div className="text-white/30 text-[10px] tracking-[0.2em] leading-none mt-0.5 font-inter">
              MARINE & ENGINEERING
            </div>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const active = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`relative px-4 py-2 text-sm tracking-widest uppercase font-medium transition-all duration-200 cursor-pointer font-inter ${
                  active ? "text-[#00ff88]" : "text-white/60 hover:text-white"
                }`}
              >
                {link.label}
                {active && (
                  <span className="absolute bottom-0 left-4 right-4 h-px bg-[#00ff88]" />
                )}
              </Link>
            );
          })}
        </nav>

        {/* Mobile Burger */}
        <button
          className="md:hidden w-9 h-9 flex items-center justify-center text-white/70 hover:text-white cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-[#0a0a0a]/98 border-t border-white/5 px-6 py-4 flex flex-col gap-1">
          {navLinks.map((link) => {
            const active = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 text-sm tracking-widest uppercase font-medium transition-all cursor-pointer font-inter ${
                  active ? "text-[#00ff88]" : "text-white/60"
                }`}
              >
                {link.label}
              </Link>
            );
          })}

        </div>
      )}
    </header>
  );
}
